import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  user-select: none;
  display: flex;
  flex-wrap: nowrap;
  justify-content: stretch;

  @media screen and (max-width: 820px) {
    justify-content: space-around;
    align-items: center;
  }

  @media screen and (max-width: 600px) {
    padding-left: 30px;
    padding-right: 30px;
    box-sizing: border-box;
  }
`

const ListButton = styled.button`
  outline: none;
  padding: 15px 30px;
  border: 0;
  margin: 0;
  background-color: transparent;
  font-size: 18px;
  font-weight: ${props => (props.active === false ? '500' : '700')};
  color: ${props => (props.active === false ? '#777777' : 'black')};
  border-bottom: ${props =>
    props.active === false ? '4px solid transparent' : '4px solid black'};

  cursor: pointer;
  white-space: nowrap;

  @media screen and (max-width: 768px) {
    padding: 15px 0;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 0.01em;
    min-width: 25%;
  }
`

const Tab = ({ data, onClick, selected }) => {
  return (
    <ListButton
      active={data?.value === selected?.value ? true : false}
      onClick={e => onClick(data)}
    >
      {data.label}
    </ListButton>
  )
}

const DesignTabs = ({ options, onChange, selected }) => {
  return (
    <Container>
      {options.map(item => (
        <Tab
          key={item.value}
          data={item}
          onClick={onChange}
          selected={selected}
        />
      ))}
    </Container>
  )
}

export default DesignTabs
